import { useEffect, useState } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "aaa-cookie-notice-dismissed";

export default function CookieNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const dismissed = window.localStorage.getItem(STORAGE_KEY);
    if (!dismissed) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    window.localStorage.setItem(STORAGE_KEY, "1");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-notice"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-40 bg-[#1A1A1A] text-[#F7F5F2] border border-[#1A1A1A] shadow-[0_18px_40px_-20px_rgba(0,0,0,0.5)]"
    >
      <div className="p-5 md:p-6 flex items-start gap-4">
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#1FA5B8] font-body mb-2">
            A small note
          </div>
          <p className="font-body text-[13px] leading-[1.6] text-[#F7F5F2]/85">
            This site uses lightweight, privacy-friendly analytics to
            understand how visitors find their way. No personal data is
            stored, no cookies are set for tracking. By continuing, you
            accept this gentle measurement.
          </p>
        </div>
        <button
          onClick={dismiss}
          data-testid="cookie-dismiss"
          aria-label="Dismiss"
          className="text-[#F7F5F2]/60 hover:text-[#1FA5B8] transition-colors shrink-0"
        >
          <X size={18} strokeWidth={1.6} />
        </button>
      </div>
    </div>
  );
}
